import { Component, Input, OnInit } from '@angular/core';
import { IRecordSearchResult } from '../record-search-result';

@Component({
  selector: 'app-global-search-record-results',
  template: `<mat-nav-list dense>
    <a
      mat-list-item
      [routerLink]="[
        '/module',
        r.recordLink.moduleId,
        'detail',
        r.recordLink.recordId
      ]"
      *ngFor="let r of results"
    >
      <mat-icon [style.overflow]="'visible'" class="text-muted" mat-list-icon
        >search</mat-icon
      >
      <div
        mat-list-icon
        [style.display]="'flex'"
        [style.flex-direction]="'column'"
        [style.width]="'auto'"
        [style.min-width.px]="50"
        [style.align-items]="'center'"
        [style.justify-content]="'center'"
      >
        <app-module-icon [icon]="r.module.icon" [size]="20"></app-module-icon>
        <div class="module-name-label">
          <span>{{ r.module.name }}</span>
        </div>
      </div>
      <div
        mat-line
        *ngFor="let m of r.matches"
        class="list-item-text-container"
      >
        <ng-container>
          <span [style.margin-right.px]="4" [style.font-weight]="600">
            {{ m.label || m.fieldId }}
          </span>
          <span
            [innerHTML]="
              m.value
                | solSpotlight : term : 25
                | solHighlight : term : 'elevate'
            "
          >
          </span>
        </ng-container>
      </div>
    </a>
    <mat-divider></mat-divider>
  </mat-nav-list>`,
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
      }

      .mat-list-base[dense] .mat-list-item .mat-list-icon .module-name-label {
        font-weight: 600;
        display: flex;
        font-size: 0.49em !important;
        padding: 0;
        text-align: center;
        min-width: 30px;
        flex-direction: column;
        align-content: center;
        justify-content: center;
        box-sizing: content-box;
        width: auto !important;
        height: auto !important;
        line-height: normal;
      }
      [mat-line].list-item-text-container.list-item-text-container {
        display: flex;
        align-items: center;
        font-size: 0.9em !important;
        line-height: 18px;
      }
    `,
  ],
})
export class GlobalSearchRecordResultsComponent implements OnInit {
  @Input()
  term!: string;
  @Input()
  results: IRecordSearchResult[] = [];

  ngOnInit(): void {}
}
